import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import '../styles/Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <div className="home-content">
        <h1 className="home-title">
          <span className="greeting">Hola, soy</span>
          <span className="name">Julián Calle</span>
          <span className="title">Desarrollador Web Full Stack</span>
        </h1>
        
        <p className="home-description">
          Técnico Superior en Desarrollo de Aplicaciones Web, con experiencia en Desarrollo y Arquitectura de Software.
        </p>
        
        <div className="home-buttons">
          <Link to="/trayectoria" className="btn-primary">
            Ver Trayectoria <FontAwesomeIcon icon={faArrowRight} />
          </Link>
          <Link to="/contacto" className="btn-secondary">
            Contactar
          </Link>
        </div>
      </div>
      
      <div className="home-image">
        <img src="/images/user_image.jpeg" alt="Julián Calle" className="profile-image" />
      </div>
    </div>
  );
};

export default Home; 